import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ejecutivos',
  templateUrl: './ejecutivos.component.html',
  styleUrls: ['./ejecutivos.component.css']
})
export class EjecutivosComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
